module.exports = __webpack_public_path__ + "img/grey_013.24bd7edc.png";